<ion-item
  [id]="'openPicker_' + id"
  class="form-element-wrapper"
  [class.item-interactive-disabled]="formCtrl.disabled"
  [class.ion-invalid]="formCtrl.invalid"
  [class.ion-touched]="formCtrl.touched"
  [ngClass]="labelPosition + '_label'"
  fill="outline"
  mode="md"
>
  <ion-label *ngIf="label" [position]="labelPosition">{{ label }}</ion-label>

  <ion-input
    readonly="true"
    type="text"
    autocomplete="off"
    [placeholder]="placeholder"
    [value]="formCtrl.value | date : (presentation === 'date' ? 'dd/MM/yyyy' : 'dd/MM/yyyy HH:mm')"
    [disabled]="formCtrl.disabled"
  >
  </ion-input>

  <fa-icon *ngIf="!formCtrl.disabled" slot="end" [icon]="faCalendarDay" size="xl"></fa-icon>
</ion-item>

<mom-validation-text [formCtrl]="formCtrl"></mom-validation-text>

@if (!formCtrl.disabled) {
<ion-datetime-button #calendarTrigger [datetime]="'calendarPicker_' + id" class="ion-hide"></ion-datetime-button>
<ion-modal #datetimeModal [class.phone-device]="!isWeb" [trigger]="'openPicker_' + id" [keepContentsMounted]="true">
  <ng-template>
    <ion-datetime
      mode="md"
      color="secondary"
      [id]="'calendarPicker_' + id"
      [presentation]="presentation"
      [value]="calendarFormattedDate"
      [showDefaultButtons]="true"
      [preferWheel]="!isWeb"
      [min]="min"
      [max]="max"
      (ionChange)="onCalendarChange($event)"
    ></ion-datetime>
  </ng-template>
</ion-modal>
}
